module.exports = __webpack_public_path__ + "static/media/nojen.f40dd25a.png";